export default {
    settings_title: "Ρυθμίσεις",
    toggle_dark_theme: "Σκούρο Θέμα",
    frequent_questions: "Συχνές Ερωτήσεις",
    about_us: "Σχετικά",
    license: "Άδεια Χρήσης",
    app_manual: "Εγχειρίδιο Εφαρμογής",
    share_app: "Κοινοποιήστε την εφαρμογή",
    gitlab_contribute: "Συνεισφέρετε στο έργο μας",
    settings_close: "Κλείσιμο",
    change_language: "Αλλαγή Γλώσσας",
    choose_department: "Επιλέξτε Τμήμα",
    form_feedback: "Φόρμα Αξιολόγησης"
}